import { FormControl, FormControlLabel, Radio, RadioGroup, Stack } from '@mui/material'
import type { FC } from 'react'

import H6 from '@/components/H6'

export interface Props {
  setFacialMatchSelection: (selection: boolean) => void
  facialMatch: boolean
}

const FacialMatchRadioGroup: FC<Props> = ({ setFacialMatchSelection, facialMatch }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFacialMatchSelection(event.target.value === 'true')
  }

  return (
    <Stack spacing={2} direction="row" justifyContent="space-between">
      <FormControl>
        <H6>Facial Match</H6>
        <RadioGroup
          row
          aria-labelledby="facial-match-label"
          name="facial-match"
          value={facialMatch.toString()}
          onChange={handleChange}
        >
          <FormControlLabel value="true" control={<Radio />} label="Pass" />
          <FormControlLabel value="false" control={<Radio />} label="Fail" />
        </RadioGroup>
      </FormControl>
    </Stack>
  )
}

export default FacialMatchRadioGroup
